import { render, staticRenderFns } from "./Shareandwin.container.vue?vue&type=template&id=b656a1d2&scoped=true&"
import script from "./Shareandwin.container.vue?vue&type=script&lang=ts&"
export * from "./Shareandwin.container.vue?vue&type=script&lang=ts&"
import style0 from "./Shareandwin.container.vue?vue&type=style&index=0&id=b656a1d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b656a1d2",
  null
  
)

export default component.exports